import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

type MessagingLoadErrorProps = {
  message: string;
  noWrap?: boolean;
  onRetry: () => void;
};

export default function MessagingLoadError({
  message,
  noWrap = false,
  onRetry,
}: MessagingLoadErrorProps) {
  const theme = useTheme();

  return (
    <Box
      data-test-id="messaging-load-error"
      role="alert"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: noWrap ? 'nowrap' : 'wrap',
        gap: 1,
        justifyContent: 'center',
      }}
    >
      <Typography
        noWrap={noWrap}
        sx={{ color: theme.semantic.textSecondary, minWidth: 0 }}
        variant="body2"
      >
        {message}
      </Typography>

      <SmallButton color="secondary" onClick={() => onRetry()} variant="text">
        {t('actions.retry')}
      </SmallButton>
    </Box>
  );
}
